import React from "react";
import { useTable, useBlockLayout, useResizeColumns } from 'react-table';
import { useSticky } from 'react-table-sticky';

export const Table = ({ columns, data, fixedHeader = false, extraRow }) => {
	const defaultColumn = React.useMemo(() => ({
		minWidth: 100,
		width: window.innerWidth > 1850 ? 220 : 130,
		maxWidth: 500
	}), []);

	const tableOptions = { columns, data, defaultColumn };
	const { getTableProps, headerGroups, rows, prepareRow } = useTable(tableOptions, useBlockLayout, useResizeColumns, useSticky);

	return (
		<table className={fixedHeader ? 'sticky' : ''} {...getTableProps()}>
			<thead>
				{headerGroups.map(headerGroup => (
					<tr {...headerGroup.getHeaderGroupProps()}>
						{headerGroup.headers.map(column => (
							<th className={column.headerClassName || ''} {...column.getHeaderProps()}>
								{column.render('Header')}
								<div
									{...column.getResizerProps()}
									className={`resizer ${column.isResizing ? 'isResizing' : ''}`}
								/>
							</th>
						))}
					</tr>
				))}
			</thead>
			<tbody>
				{rows.map((row, i) => {
					prepareRow(row)
					return (
						<tr {...row.getRowProps()}>
							{row.cells.map(cell => (
								<td {...cell.getCellProps()}>
									{cell.render('Cell')}
								</td>
							))}
						</tr>
					)
				})}
			</tbody>
		</table>
	)
}